import { helper } from '@ember/component/helper';
import _isEmpty from 'lodash/isEmpty';

function isEmptyObj([check]: any[] /*, hash*/) {
  return _isEmpty(check);
}
export default helper(isEmptyObj);
